/**
 * Cdn Destroy Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cdnDestroyFormatter = function(value, row) {
    let html = '';
    if (row.original_type == "directory") {
        html += '<a href="#" class="cdn-destroy-directory" data-id="'+row.id+'">';
        html += '<i class="fas fa-times"></i>';
        html += '</a>';
    }
    if (row.original_type == "file") {
        html += '<a href="#" class="cdn-destroy-file" data-id="'+row.id+'">';
        html += '<i class="fas fa-times"></i>';
        html += '</a>';
    }
    return html;
};
